<style lang="scss" scoped>
// .equ {
//   position: absolute;
//   width: 415px;
//   height: 201px;
//   right: 1px;
//   top: 438px;
//   background-image: url("../../../../../assets/pagesImg/equ-ill.png");
// }
.equ{
  width: 415px;
  height: 200px;
  margin-top: 20px;
  cursor: pointer;
  .lighting{
    margin-top: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-evenly;
    .data{
      height: 92px;
      font-size: 18px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .number{
        font-size: 48px;
        font-family: 'dina';
      }
    }
    .data:nth-child(1){
      .number{
        color:#2D82FF;
      }
    }
    .data:nth-child(3){
      .number{
        color:#F1802F;
      }
    }
    
  }
}
</style>

<template>
  <div class="equ">
    <custom-plane title="照明系统"
    :iconImg="require('@/assets/compImg/EquipmentIcon/lighting.png')">
    <div class="lighting">
        <div v-for="(item,index) in lightingList" :key="index" class="data">
            <p>{{item.title}}</p>
            <p class="number">{{item.num}}</p>
        </div>
    </div>
    </custom-plane>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        
      }
    },
    props:{
      lightingList:Array
    }
  }
  </script>
